import { __assign } from "tslib";
var OmnibarHelpButtonFoundation = /** @class */ (function () {
    function OmnibarHelpButtonFoundation(_adapter) {
        this._adapter = _adapter;
        this._options = [];
        this._isInitialized = false;
    }
    OmnibarHelpButtonFoundation.prototype.initialize = function () {
        this._adapter.initialize();
        this._adapter.setMenuOptions(this._options);
        this._isInitialized = true;
    };
    OmnibarHelpButtonFoundation.prototype.disconnect = function () {
        this._isInitialized = false;
    };
    Object.defineProperty(OmnibarHelpButtonFoundation.prototype, "options", {
        set: function (value) {
            // Intentional shallow copy of member properties. These member objects have properties that are references to functions.
            //   The typical JSON.parse(JSON.stringify(object)) will not work here. If this becomes an issue we'll add a deepClone
            //   function to the core library.
            this._options = value.map(function (o) { return (__assign({}, o)); });
            if (this._isInitialized) {
                this._adapter.setMenuOptions(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    return OmnibarHelpButtonFoundation;
}());
export { OmnibarHelpButtonFoundation };
